export default __webpack_public_path__ + "static/media/projects-icon-dark.8b3d8964.svg";